import Vue from 'vue';
import { Object } from 'core-js';
import api from './api';

class TablasConsulta {

  instantanea_estado = null;
  datos = undefined;

  constructor () {
    this.datos = new Vue ({
      data: {
        arrayRegistrosTabla: [],
        objetoRegistrosTabla: [],
      }
    });
  }

  actualizar () {
    return new Promise ((resolve, reject) => {
      api.obtenerTablasConsulta ({ ie: this.instantanea_estado })
        .then ((respuesta) => {
          if (respuesta.data.tablas_consulta) {
            Object.keys (respuesta.data.tablas_consulta).forEach ((nombreTabla) => {
              let aux = respuesta.data.tablas_consulta [nombreTabla];
              if (Array.isArray (aux)) {
                Vue.set (this.datos.arrayRegistrosTabla, nombreTabla, aux);
              } else {
                Vue.set (this.datos.arrayRegistrosTabla, nombreTabla, Object.values (aux));
                Vue.set (this.datos.objetoRegistrosTabla, nombreTabla, aux);
              }
            });
            this.instantanea_estado = respuesta.data.instantanea_estado;
          }
          resolve ();
        })
        .catch ((e) => {
          reject (e);
        });
    });
  }

  invalidar () {
    this.instantanea_estado = '';
  }

  arrayRegistros (nombreTabla) {
    let registros = this.datos.arrayRegistrosTabla [nombreTabla];
    if (registros === undefined)
      console.warn (`tablasConsultas.arrayRegistros(): No se ha encontrado la tabla de consulta "${nombreTabla}" `);
    return registros;
  }

  objetoRegistros (nombreTabla) {
    let registros = this.datos.objetoRegistrosTabla [nombreTabla];
    if (registros === undefined)
      console.warn (`tablasConsultas.objetoRegistros(): No se ha encontrado la tabla de consulta "${nombreTabla}"`);
    return registros;
  }

  registroPorClave (nombreTabla, clave, campo) {
    let registros = this.objetoRegistros (nombreTabla);
    if (registros) {
      let registro = registros [clave];
      if (registro === undefined)
        console.warn (`No se ha encontrado la clave "${clave}" en la tabla de consulta "${nombreTabla}"`);
      else if (campo) {
        let valor = registro [campo];
        if (valor === undefined)
          throw new Error (`No se ha encontrado el campo "${campo}" en la tabla de consulta "${nombreTabla}"`);
        return valor;
      } else
        return registro;
    }
  }

  localizarRegistro (nombreTabla, camposYValores, resultadoPorDefecto = null) {
    let resultado = resultadoPorDefecto;
    let registros = this.arrayRegistros (nombreTabla);
    let arrayCamposYValores = Object.entries (camposYValores);
    registros.some ((registro) => {
      if (arrayCamposYValores.every (([campo, valor]) => registro[campo] == valor)) {
        resultado = registro;
        return true;
      }
    });
    return resultado;
  }

}

export default TablasConsulta